import { hero } from '../shared/primitives-v4';
import type { PortalGradients } from '../types';

export const v4Gradients: PortalGradients = {
  backgroundGradient: `linear-gradient(180deg, ${hero[400]} 0%, ${hero[700]} 8%, ${hero[900]} 31%)`,
};
